<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="礼物名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入礼物名称" />
      </a-form-model-item>
      <a-form-model-item label="花费金豆数" prop="goldenBeans" >
        <a-input v-model="form.goldenBeans" placeholder="请输入花费金豆数" />
      </a-form-model-item>
      <a-form-model-item label="图片地址" prop="imgUrl" >
        <a-input v-model="form.imgUrl" placeholder="请输入图片地址" />
      </a-form-model-item>
      <a-form-model-item label="特效地址" prop="giftEffects" >
        <a-input v-model="form.giftEffects" placeholder="请输入特效地址" />
      </a-form-model-item>
      <a-form-model-item label="排序, asc" prop="sort" >
        <a-input v-model="form.sort" placeholder="请输入排序, asc" />
      </a-form-model-item>
      <a-form-model-item label="是否启用, 0-禁用, 1-启用, 默认-1" prop="isEnabled" >
        <a-input v-model="form.isEnabled" placeholder="请输入是否启用, 0-禁用, 1-启用, 默认-1" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGift, addGift, updateGift } from '@/api/gift/gift'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        createTime: null,

        remark: null,

        name: null,

        goldenBeans: null,

        imgUrl: null,

        giftEffects: null,

        sort: null,

        isEnabled: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '礼物名称不能为空', trigger: 'blur' }
        ],
        goldenBeans: [
          { required: true, message: '花费金豆数不能为空', trigger: 'blur' }
        ],
        imgUrl: [
          { required: true, message: '图片地址不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序, asc不能为空', trigger: 'blur' }
        ],
        isEnabled: [
          { required: true, message: '是否启用, 0-禁用, 1-启用, 默认-1不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        createTime: null,
        remark: null,
        name: null,
        goldenBeans: null,
        imgUrl: null,
        giftEffects: null,
        sort: null,
        isEnabled: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGift({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGift(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGift(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
